import { axiosInstance } from 'boot/axios.js'

export async function verify(ctx, data = {}) {
  try {
    const response = await axiosInstance({
      url: '/verify-account',
      method: 'POST',
      data
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}
